import { useEffect, useState } from "react";
import { useFetch } from "./hooks/useFetch";
import Dashboard from "./Pages/Dashboard";
import Login from "./Pages/Login";
import Main from "./Pages/Main";
import TodoList from "./Pages/TodoList";
import ErrorBoundary from "./ErrorBoundary";
import { Route, Switch, Routes, Link, Navigate } from "react-router-dom";

import ResetPassword from "./Pages/ResetPassword";

function App() {
    const [loggedIn, setLoggedIn] = useState(false);
    const [userData, setUserData] = useState({});
    const [token, setToken] = useState(localStorage.getItem("access_token"));
    const [object_state_sessions, set_object_state_sessions] = useState({});
    const [msgErrorLogin, setMsgErrorLogin] = useState("");
    // --- CONFIGURACIÓN MAESTRA DEL SERVIDOR (NO MODIFICAR) ---
    const SERVER_CONFIG = {
        url: "https://api-saimontechma.gruposeguritech.com", // API Producción
        ip: "40.119.41.131", // IP Azure (Referencia)
        port: 443,
        protocol: "https",
        // WebSocket apuntando a la API segura
        ws: "wss://api-saimontechma.gruposeguritech.com",
    };
    const [server, setServer] = useState(SERVER_CONFIG);

    // const [server,setServer]=useState({ip:'10.60.20.250',port:8000})//Hidalgo
    // const [server, setServer] = useState({url:"http://10.60.20.251:8000", ip: "10.60.20.251", port: 8000 ,protocol:'http', ws:'ws://10.60.20.251:8000' }); //Hidalgo
    // const [server,setServer]=useState({ip:'172.16.4.249',port:8000})//EDOMEX
    // const [server, setServer] = useState({url:"http://172.16.4.249:8000", ip: "172.16.4.249", port: 8000 ,protocol:'http', ws:'ws://172.16.4.249:8010' }); //EDOMEX
    // const [server,setServer]=useState({ip:'52.255.122.55',port:8000})//GTO2
    // const [server, setServer] = useState({ ip: "40.124.142.53", port: 8000 }); //AZURE GTO
    // const [server, setServer] = useState({url:"http://10.70.21.48:8000", ip: "10.70.21.48", port: 8000 ,protocol:'http', ws:'ws://10.70.21.48:8000' }); //Sonora

    // const [server, setServer] = useState({ url: "http://172.18.200.14:8000", ip: "172.18.200.14", port: 8000, protocol: 'http', ws: 'ws://172.18.200.14:8000' }); //Guanajuato
    // const [server, setServer] = useState({url:"http://10.250.200.72:8000", ip: "10.250.200.72", port: 8000 ,protocol:'http', ws:'ws://10.250.200.72:8000' }); //Guanajuato Conect.
    // const [server, setServer] = useState({url:"http://10.169.208.8:8000", ip: "10.169.208.8", port: 8000 ,protocol:'http', ws:'ws:// :8000' }); //chihuahua Tz=96/&!@
    // const [server, setServer] = useState({url:"http://10.171.3.71:8000", ip: "10.171.3.71", port: 8000 ,protocol:'http', ws:'ws://10.171.3.71:8000' }); //chihuahua nuevo  Tz=96/&!@
    // const [server,setServer]=useState({ip:'10.12.1.61',port:8000})//Zacatecas
    // const [server,setServer]=useState({ip:'10.53.1.9',port:8000})//BajaCalifornia
    // const [server, setServer] = useState({url:"http://10.0.131.35:8000", ip: "10.0.131.35", port: 8000 ,protocol:'http', ws:'ws://10.0.131.35:8000' }); //JAlsco
    // const [server, setServer] = useState({url:"http://10.53.1.9:8002", ip: "10.53.1.9", port: 8002 ,protocol:'http', ws:'ws://10.53.1.9:8002' }); //BAJA
    //  const [server, setServer] = useState({url:"http://10.89.8.69:8000", ip: "10.89.8.69", port: 8000 ,protocol:'http', ws:'ws://10.89.8.69:8000' }); //QRO
    // const [server, setServer] = useState({url:"http://10.53.1.9:8002", ip: "10.53.1.9", port: 8002 ,protocol:'http', ws:'ws://10.53.1.9:8002' }); //BAJA
    // const [server, setServer] = useState({url:"http://localhost:8002", ip: "localhost", port: 8002 ,protocol:'http', ws:'ws://localhost:8002' }); //localhost
    // const [server, setServer] = useState({url:"http://10.180.210.163:8000", ip: "10.53.1.9", port: 8002 ,protocol:'http', ws:'ws://10.53.1.9:8002' }); //Cancun
    // const [server,setServer]=useState({ip:'10.169.208.8',port:8002})//Chihuahua
    //  const [server,setServer]=useState({ip:'10.191.80.146',port:8000})//Merida
    // console.log("app");
    // console.log(server)
    useEffect(() => {
        // set_object_state_sessions(JSON.parse(localStorage.getItem('object_state_sessions')))
        localStorage.setItem("main_server_ip", server.ip);
        localStorage.setItem("main_server_port", server.port);
        localStorage.setItem("main_server_url", server.url);
        localStorage.setItem("main_server_protocol", server.protocol);
        localStorage.setItem("main_server_ws", server.ws);
        // console.log('reinicio la pagina')
        if (token === null) {} else {
            if (
                localStorage.getItem("access_token") !==
                localStorage.getItem("main_access_token")
            ) {
                localStorage.setItem(
                    "access_token",
                    localStorage.getItem("main_access_token")
                );
            }
            setLoggedIn(true);
        }
    }, []);
    const handleLogin = (e) => {
        // console.log(e)
        // setLoggedIn((loggedIn?false:true));
        if (loggedIn) {
            setServer({
                ip: localStorage.getItem("main_server_ip"),
                port: localStorage.getItem("main_server_port"),
                url: localStorage.getItem("main_server_url"),
                protocol: localStorage.getItem("main_server_protocol"),
                ws: localStorage.getItem("main_server_ws"),
            });
            set_object_state_sessions({});
            localStorage.removeItem("aux_change_state");
            localStorage.removeItem(
                "password_cassia_" + localStorage.getItem("main_access_token")
            );
            localStorage.removeItem("access_token");
            localStorage.removeItem("user_session");
            localStorage.removeItem("user_cassia");
            localStorage.removeItem("main_access_token");
            localStorage.removeItem("object_state_sessions");
            localStorage.removeItem("aux_server_ip");
            localStorage.removeItem("MsgErrorLogin");
            localStorage.removeItem("ErrorLogin");
            localStorage.removeItem("aux_server_port");
            localStorage.removeItem("data_info_marker");
            setLoggedIn(false);
        } else {
            setUserData(e);

            localStorage.setItem("user_session", JSON.stringify(e.data));
            localStorage.setItem("access_token", e.data.access_token);
            localStorage.setItem("main_access_token", e.data.access_token);
            setLoggedIn(true);
        }
    };
    return (
        <ErrorBoundary>
            <Routes>
                <Route
                    path="/"
                    element={
                        loggedIn ? (
                            <Navigate to="/main" />
                        ) : (
                            <Login
                                onLogin={handleLogin}
                                msgErrorLogin={msgErrorLogin}
                                setMsgErrorLogin={setMsgErrorLogin}
                                server={server}
                                token={token}
                                setToken={setToken}
                                userData={userData}
                                setUserData={setUserData}
                            />
                        )
                    }
                ></Route>
                <Route
                    path="/main"
                    element={
                        loggedIn ? (
                            <Main
                                setMsgErrorLogin={setMsgErrorLogin}
                                object_state_sessions={object_state_sessions}
                                set_object_state_sessions={set_object_state_sessions}
                                setServer={setServer}
                                onLogin={handleLogin}
                                token={token}
                                server={server}
                                setToken={setToken}
                                userData={userData}
                                setUserData={setUserData}
                            />
                        ) : (
                            <Navigate to="/" />
                        )
                    }
                ></Route>
                <Route
                    path="/todoList"
                    element={
                        // loggedIn ? (
                        <TodoList
                            setMsgErrorLogin={setMsgErrorLogin}
                            object_state_sessions={object_state_sessions}
                            set_object_state_sessions={set_object_state_sessions}
                            setServer={setServer}
                            onLogin={handleLogin}
                            token={token}
                            server={server}
                            setToken={setToken}
                            userData={userData}
                            setUserData={setUserData}
                        />
                        // ) 
                        // : (
                        //   <Navigate to="/" />
                        // )
                    }
                ></Route>

                <Route
                    path="/reset-password"
                    element={<ResetPassword server={server} />}
                />
            </Routes>
        </ErrorBoundary>
    );
}

export default App;
